<template>
  <div>
    <div>
      <div v-if="caixaStore.aberto"
           class="d-flex align-items-center mb-2 ml-2">
        <b-form-checkbox id="selecionar-todos"
                         @change="selecionarTodosItens"> 
          <label for="selecionar-todos" 
                 class="mr-4">Selecionar todos os itens
          </label>
        </b-form-checkbox>
        <div class="d-flex align-items-center h-25 mb-2">
          <button class="btn btn-sm btn-default btn-excluir d-flex align-items-center justify-content-between font-weight-bold"
                  type="button"
                  :disabled="!lixeiraHabilitada"
                  @click="excluir($bvModal)">
            <IconSvg class="Excluir-icon icon--sm trash"
                     icon="trash" />
            Excluir
          </button>
        </div>
      </div>
    </div>  
    <table class="mx-auto col-12 ">
      <thead :style="color">
        <tr>
          <td class="text-left pl-5 w-25 col-2">
            Data
          </td>
          <td class="text-left pl-3 pr-2 w-25 col-3">
            Solicitante
          </td>
          <td class="text-left pt-2 pb-2 w-25 col-2"> 
            Tipo de Serviço
          </td>
          <td class="text-left  pt-2 pb-2 w-25 col-3"> 
            Forma de pagamento
          </td>
          <td class="text-left pl-4 col-2"> 
            Valor
          </td>
          <td class="text-left" />
        </tr>
      </thead>
      <tbody class="table dados-da-tabela border-top-0 text-left">
        <tr v-for="item in frenteCaixa.pedidos" 
            :key="item.cx_pedido_id">
          <td v-if="item.tipo_pedido !== 'O.S'"
              class="pl-4 pt-4 text-center">
            <b-form-checkbox 
              v-model="item.habilitar"
              @change="checkboxIndividualHabilitado"> 
              <span class="mt-2 text-center">
                {{ item.data_lancamento | date }}
              </span>
            </b-form-checkbox>
          </td>
          <td v-else 
              class="pl-5 pt-4">
            <span class="mt-2 text-center">
              {{ item.data_lancamento | date }}
            </span>
          </td>
          <td class="pl-3 pt-4 text-left">
            {{ item.solicitante? item.solicitante : '---' }}
          </td>
          <td class="pl-4 pt-4 text-left">
            {{ item.tipo_pedido? item.tipo_pedido : item.tipo }}
          </td>
          <td class=" pt-4 text-left">
            <span :id="`recebimento-avulso-tooltip${item.cx_pedido_id}`">
              {{ item.parcelas.length > 1 ? 'Diversas' : item.parcelas[0].forma_pg }}
              <b-badge v-if="item.parcelas.length > 1"
                       variant="light">
                {{ item.parcelas.length }}
              </b-badge>
              <icon-svg v-show="item.parcelas.length > 1"
                        icon="helpCircle"
                        class="icon--sm icon ml-2"
                        style="fill: #074f7f !important;" />
            </span>
            <b-tooltip v-if="item.parcelas.length > 1"
                       :target="`recebimento-avulso-tooltip${item.cx_pedido_id}`"
                       triggers="hover">
              <div v-for="(parcela, index) in item.parcelas"
                   :key="index">
                <div class="d-flex justify-content-between">
                  <span class="mr-1">{{ parcela.forma_pg }}</span>
                  <span>{{ parcela.valor }}</span>
                </div>                  
              </div>
            </b-tooltip>
          </td>
          <td class="pt-4 text-left">
            <input id="custa_valor_total_custa"
                   v-money="money"
                   :value="item.valorTotal"
                   disabled
                   class="valor text-left pl-3" 
                   :class="{'is-invalid' : errors.has('custa_ipesp')}"
                   name="custa_ipesp"
                   size="sm"
                   trim>
          </td>
          <td>
            <EditarPagamento v-if="caixaStore.aberto"
                             :prop-pedido="item" />
          </td>
        </tr>
        
        <!-- Exibir dados de Pagamentos Avulsos -->
        <tr v-for="itemPagamento in frenteCaixa.despesas"   
            :key="itemPagamento.cx_lancamento_id">
          <td v-if="itemPagamento.tipo == 'despesa' && itemPagamento.status_pg == 'concluido'"
              class="pl-4 pt-4 text-center">
            <b-form-checkbox 
              v-model="itemPagamento.habilitar"
              @change="checkboxIndividualHabilitado"> 
              <span class="mt-2 text-center">
                {{ itemPagamento.data_lancamento | date }}
              </span>
            </b-form-checkbox>
          </td>
          <td v-if="itemPagamento.status_pg == 'concluido'"
              class="pl-3 pt-4 text-left">
            {{ itemPagamento.beneficiario? itemPagamento.beneficiario : '---' }}
          </td>
          <td v-if="itemPagamento.status_pg == 'concluido'" 
              class="pl-4 pt-4 text-left">
            {{ itemPagamento.tipo? itemPagamento.tipo : '---' }}
          </td>
          <td v-if="itemPagamento.status_pg == 'concluido'"
              class="pl-3 pt-4 text-left">
            {{ itemPagamento.forma_pg? itemPagamento.forma_pg : '---' }}
          </td>
          <td v-if="itemPagamento.status_pg == 'concluido'" 
              class="pt-4 text-center">
            <input id="custa_valor_total_custa"
                   v-money="money"
                   :value="itemPagamento.valor_total"
                   disabled
                   class="valor text-left pl-3 text-danger" 
                   :class="{'is-invalid' : errors.has('custa_ipesp')}"
                   name="custa_ipesp"
                   size="sm"
                   trim>
          </td>
          <td v-if="itemPagamento.tipo == 'despesa' && itemPagamento.status_pg == 'concluido'"
              class="pl-3 pt-3 text-center">
            <ModalEditarDespesa v-if="caixaStore.aberto"
                                :prop-pagamento="itemPagamento"
                                :prop-atualizar-status="atualizacaoDeLancamentos" />
          </td>
        </tr>
      </tbody>
    </table>
    <ConfirmacaoExclusaoLancamento 
      :prop-itens-habilitados="itensHabilitados" 
      @verificar="verificarExclusaoLancamento" />
    <RemocaoLancamento 
      :atualizacao-de-lancamentos="[atualizacaoDeLancamentos, 'todos']" 
      @mensagem="msgTextArea" />
  </div>
</template> 

<script>
 //Components
  import ModalEditarDespesa from "../../ModalEditar/ModalEditarDespesa.vue"
  import RemocaoLancamento from "../../RemocaoLancamento/RemocaoLancamento"
  import ConfirmacaoExclusaoLancamento from "../../RemocaoLancamento/ConfirmacaoExclusaoLancamento"
  import EditarPagamento from "../../../FrenteDeCaixaPendentes/EditarPagamento.vue"

  // Imports
  import { VMoney } from 'v-money'
  import  pedidoService from '../../../pedidoService'
  import  lancamentoService from '../../../lancamentoService'

  // vuex
  import { mapState } from 'vuex'

  export default {
    name: "TabelaFiltroTodos",
    directives: {
      money: VMoney
    }, 
    components: {
      ModalEditarDespesa,
      RemocaoLancamento,
      ConfirmacaoExclusaoLancamento,
      EditarPagamento
    },
    data () {
      return {
        color: {
          backgroundColor: "#57bd9c",
        },
        lixeiraHabilitada: false,
        textoJustificativa: '',
        arrayExcluidosCxPedido: [],
        arrayExcluidosCxLancamento: [],
        corfirmarExclusao: false,
        itensHabilitados: [],
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        },
        filtro: {
          status: 'concluido',
          tipoServico: '',
          data: '',
          numOs: '',
          solicitante: '',
          formaPg: '',
          page: 1,
          perPage: 20,
          lastPage: '',
        }
      }
    }, 
    computed: { 
      ...mapState(['frenteCaixa']),
      cxData () {
        return this.$store.state.frenteCaixa.cxData
      },
      filtroStore () {
        return this.$store.state.frenteCaixa.filtro
      },
      caixaStore () {
        return this.$store.state.frenteCaixa.caixa
      },
    },
    methods: {
      selecionarTodosItens (event) {
        const percorrendoPedidosELista = obj => {
          if (!event) {
            obj.habilitar = false
            this.lixeiraHabilitada = false
            return
          } else if (event &&  this.lixeiraHabilitada ) {
            this.lixeiraHabilitada = false
          }
          obj.habilitar = true
          this.lixeiraHabilitada = true
        }

        this.frenteCaixa.pedidos.forEach(percorrendoPedidosELista)
        this.frenteCaixa.despesas.forEach(percorrendoPedidosELista)
      },
      checkboxIndividualHabilitado (event) {
        if (event) return this.lixeiraHabilitada = true
        let habilitados =  this.frenteCaixa.pedidos.filter(obj => obj.habilitar)
        habilitados = [...habilitados, ...this.frenteCaixa.despesas.filter(obj => obj.habilitar)]

        if (habilitados.length > 1) {
          this.lixeiraHabilitada = true
          
        } else if (habilitados.length == 1 ) {
          this.lixeiraHabilitada = false
          habilitados[0].habilitar = false 
        } 
      }, 
      async atualizarStatus () {
        this.$store.dispatch('frenteCaixa/atualizarPedidos')    

      },
      excluir (mostrarModal) {
        let habilitados =  this.frenteCaixa.pedidos.filter(obj => obj.habilitar)
        this.itensHabilitados = [...habilitados, ...this.frenteCaixa.despesas.filter(obj => obj.habilitar)]
    
        if (!this.corfirmarExclusao) {
          mostrarModal.show('show-modal-confirmacao-lancamento')
        }
       
        if (this.corfirmarExclusao) {
          mostrarModal.show('show-modal-confirmacao')
          this.corfirmarExclusao = false
        }

      },
      atualizacaoDeLancamentos () {
        this.atualizarStatus ()
        this.arrayExcluidosCxPedido = []
        this.arrayExcluidosCxLancamento = []
        this.lixeiraHabilitada = false
        this.textoJustificativa = ''
        this.itensHabilitados = []
      },
      async msgTextArea (texto) {
        try {
          this.textoJustificativa = texto
         
          this.frenteCaixa.pedidos.forEach (item => {
            if (item.cx_pedido_id && item.habilitar && item.lancamentosAvulso ) {
              this.arrayExcluidosCxPedido.push(item)
            }
          })
  
          this.frenteCaixa.despesas.forEach (item => {
            if (item.cx_lancamento_id && item.habilitar) {
              this.arrayExcluidosCxLancamento.push(item)
            }
          })

          if (this.arrayExcluidosCxPedido.length && this.arrayExcluidosCxLancamento.length) {
            await pedidoService.excluirRecebimentosAvulsos({arrayExcluidos: this.arrayExcluidosCxPedido, msg: this.textoJustificativa })
            await lancamentoService.excluirPagamentosAvulsos({arrayExcluidos: this.arrayExcluidosCxLancamento, msg: this.textoJustificativa })
            this.atualizandoPagamentosAvulsos ()

            setTimeout (async () => {
              this.mensagemDeExclusao('')
            }, 2000)
            this.atualizacaoDeLancamentos()
            return
          }
    
          if (this.arrayExcluidosCxPedido.length) {
            await pedidoService.excluirRecebimentosAvulsos({arrayExcluidos: this.arrayExcluidosCxPedido, msg: this.textoJustificativa })
            this.atualizandoPagamentosAvulsos () 

            setTimeout (() => {
              this.mensagemDeExclusao('CxPedido')
            }, 2000)
          }
  
          if (this.arrayExcluidosCxLancamento.length) {
            await lancamentoService.excluirPagamentosAvulsos({arrayExcluidos: this.arrayExcluidosCxLancamento, msg: this.textoJustificativa })
            this.atualizandoPagamentosAvulsos ()

            setTimeout (() => {
              this.mensagemDeExclusao('CxLancamento')
            }, 2000)
          }
          
        } catch (error) {
          // const message = getErrors(error)
          // displayMessage('error', 'Erro!', message.message)
        }
      },
      mensagemDeExclusao (texto) {
        switch (texto) {
        case 'CxPedido':
          objSwal.success.title = this.arrayExcluidosCxPedido.length ? this.arrayExcluidosCxPedido.length  > 1 ? `Pedidos excluídos com sucesso.` : `Pedido excluído com sucesso.` : ''
          Swal.fire(objSwal.success)
          break
        case 'CxLancamento':
          objSwal.success.title = this.arrayExcluidosCxLancamento.length ? this.arrayExcluidosCxLancamento.length  > 1 ? `Lançamentos excluídos com sucesso.` : `Lançamento excluído com sucesso.` : ''
          Swal.fire(objSwal.success)
          break
        default:
          objSwal.success.title = `Pedido e Lançamento excluído com sucesso.`
          Swal.fire(objSwal.success)
          break
        }    
      }, 
      verificarExclusaoLancamento (modal) {
        this.corfirmarExclusao = true
        this.excluir(modal)
      }
    }
  }
</script>

<style scoped>
    .trash {
      width:15px;
    }
    .valorIndice {
      padding-left:50px;
    }
    .btn-excluir {
      cursor:pointer;
      font-size: 1.2rem;
      width:100px;
    }
    thead {
      border-right: 1.5px solid #57bd9c;
      border-left: 1px solid #57bd9c;
      font-size:1.2rem;
      font-weight: bolder;
    }
    .dados-da-tabela {
      border: 0.5px solid #C6C6C6;
    }
    .dados-da-tabela .valor {
      width:130px;
    }
    tbody tr {
      border-top: 0.5px solid #C6C6C6;
    }
    tbody tr:hover {
      background-color:#f5f5f5;
      cursor:pointer;
    }
    .icon {
      width: 20px;
    }
</style>
